import store from '@/store'
export const claimRegister = (to, from, next) => {
  // if (store.state.claims.claimDetail.commonInfo.statusCode === 'O' || store.state.claims.claimDetail.commonInfo.statusCode === 'C') {
  //   const { claimLifeCycle } = store.state.claims.claimDetail
  //   // claimNew is 1
  //   if (claimLifeCycle < 1) {
  //     // For New, can only go back to Claim New
  //     next({ name: 'claimHeader' })
  //   } else {
  //     next()
  //   }
  // } else {
  //   next({ name: 'claimRegister' })
  // }
  next()
}

export const claimHeader = (to, from, next) => {
  // if (store.state.claims.claimDetail.commonInfo.statusCode === 'O' || store.state.claims.claimDetail.commonInfo.statusCode === 'C') {
  //   const { claimLifeCycle } = store.state.claims.claimDetail
  //   // claimHeader is 2
  //   if (claimLifeCycle < 2) {
  //     // YY: Commented as per SonarLint 21-Apr-20
  //     // if (claimLifeCycle === 1) {
  //     //   next({ name: 'claimHeader' })
  //     // } else {
  //     //   next({ name: 'claimHeader' })
  //     // }
  //     next({ name: 'claimHeader' })
  //   } else {
  //     next()
  //   }
  // } else {
  //   next({ name: 'claimRegister' })
  // }
  next()
}

export const claimClaimant = (to, from, next) => {
  // if (store.state.claims.claimDetail.commonInfo.statusCode === 'O' || store.state.claims.claimDetail.commonInfo.statusCode === 'C') {
  //   const { claimLifeCycle } = store.state.claims.claimDetail
  //   // claimClaimant is 3
  //   if (claimLifeCycle < 3) {
  //     if (claimLifeCycle === 1) {
  //       next({ name: 'claimHeader' })
  //     // } else {
  //       // next({ name: 'claimHeader' })
  //     }
  //     next({ name: 'claimHeader' })
  //   } else {
  //     next()
  //   }
  // } else {
  //   next({ name: 'claimRegister' })
  // }
  next()
}

export const claimItems = (to, from, next) => {
  // if (store.state.claims.claimDetail.commonInfo.statusCode === 'O') {
  //   const { claimLifeCycle } = store.state.claims.claimDetail
  //   // claimItem is 4
  //   if (claimLifeCycle < 4) {
  //     if (claimLifeCycle === 1) {
  //       next({ name: 'claimHeader' })
  //     } else if (claimLifeCycle === 2) {
  //       next({ name: 'claimHeader' })
  //     } else if (claimLifeCycle === 3) {
  //       next({ name: 'claimClaimant' })
  //     } else {
  //       next({ name: 'claimItem' })
  //     }
  //   } else {
  //     next()
  //   }
  // } else {
  //   next({ name: 'claimRegister' })
  // }
  next()
}

export const claimReserve = (to, from, next) => {
  // if (store.state.claims.claimDetail.commonInfo.statusCode === 'O') {
  //   const { claimLifeCycle } = store.state.claims.claimDetail
  //   // claimReserve is 5
  //   if (claimLifeCycle < 5) {
  //     if (claimLifeCycle === 1) {
  //       next({ name: 'claimHeader' })
  //     } else if (claimLifeCycle === 2) {
  //       next({ name: 'claimHeader' })
  //     } else if (claimLifeCycle === 3) {
  //       next({ name: 'claimClaimant' })
  //     } else if (claimLifeCycle === 4) {
  //       next({ name: 'claimItem' })
  //     } else {
  //       next({ name: 'claimNew' })
  //     }
  //   } else {
  //     next()
  //   }
  // } else {
  //   next({ name: 'claimRegister' })
  // }
  next()
}

export const claimReinsurance = (to, from) => {
  const { claimLifeCycle } = store.state.claim.claimDetail
  switch (claimLifeCycle) {
    case 3: {
      to({ name: 'claimClaimant' })
      break
    }
    case 4: {
      to({ name: 'claimItem' })
      break
    }
    case 5: {
      to({ name: 'claimReserve' })
      break
    }
    default: {
      to({ name: 'claimRegister' })
      break
    }
  }
}
